<template>
  <div>
    <label v-if="label"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span></label
    >
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div :id="id" style="margin-top: 0.5em">
      <!-- Elements will create input elements here -->
    </div>

    <!-- We'll put the error messages in this element -->
    <div
      class="mt-2"
      id="card-errors"
      role="alert"
      style="font-size: 1rem; font-weight: 700; color: red"
    ></div>
    <p class="required-message" v-show="submitClicked && isRequired">
      <span id="payment-info-error">
        <span :id="STRIPE_PAYMENT_ERROR_IDS.EMPTY">The field is required.</span>
      </span>
    </p>
  </div>
</template>
<script>
import { STRIPE_PAYMENT_ERROR_IDS } from "../../../constants/custom-define-type";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "StripePayment",
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    isRequired: {
      type: Boolean,
      default: false,
    },
    submitClicked: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "card-element",
    },
  },
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      cardError: false,
      isStripeSetup: false,
      STRIPE_PAYMENT_ERROR_IDS: STRIPE_PAYMENT_ERROR_IDS,
      unwatch: null,
      paymentMethodId: null,
    };
  },
  mounted() {
    this.setUpStripe();
    this.unwatch = this.$store.watch(
      (state) => state.agency.agencyPublic,
      (val) => {
        if (!val) {
          return;
        }
        this.setUpStripe();
      },
      { immediate: true }
    );
  },
  beforeDestroy() {
    if (this.unwatch) {
      this.unwatch();
    }
  },
  computed: {
    ...mapGetters(["agencyCurrency", "registrationFeeStripeDescription"]),
    isCardComplete() {
      if (this.card) {
        return this.card._complete;
      } else {
        return false;
      }
    },
  },
  methods: {
    setUpStripe() {
      if (
        !this.$store.getters.agencyPublic ||
        !Object.keys(this.$store.getters.agencyPublic).length
      ) {
        // Not finish loading
        return;
      }
      if (this.isStripeSetup) {
        return;
      }
      this.isStripeSetup = true;
      this.stripe = Stripe("pk_live_uQWLhWijqTDmzPz1heFX42gd00M0Oov1EL", {
        // stripeAccount: "acct_1GDXlTE7jOFBALyf" // Test account
        //   // stripeAccount: this.$store.getters.stripeAccountID
        // stripeAccount: 'acct_1GDZdaDZMNxDtGP7' // Express
        // stripeAccount: "acct_1Bg1iOJgWhWzU0rX", // Standard
        stripeAccount: this.$store.getters.agencyPublic.stripe_account_id,
      });
      this.elements = this.stripe.elements();
      // this.elements = stripe.elements();

      let style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            // color: "#aab7c4",
            color: "#1f4e78",
          },
        },

        invalid: {
          // All of the error styles go inside of here.
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };

      this.card = this.elements.create("card", { style: style });
      this.card.mount("#" + this.id);

      this.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
          this.cardError = true;
        } else {
          displayError.textContent = "";
          this.cardError = false;
        }
        this.$nextTick(() => {
          let paymentInfoErrorInnerHtml = "";
          if (this.cardError) {
            paymentInfoErrorInnerHtml = `<span id='${STRIPE_PAYMENT_ERROR_IDS.INVALID}'>Payment information is incorrect</span>`;
          } else {
            if (this.isCardComplete) {
              paymentInfoErrorInnerHtml = "";
            } else {
              paymentInfoErrorInnerHtml = `<span id='${STRIPE_PAYMENT_ERROR_IDS.EMPTY}'>The field is required.</span>`;
            }
          }
          const paymentInfoError =
            document.getElementById("payment-info-error");
          if (paymentInfoError) {
            paymentInfoError.innerHTML = paymentInfoErrorInnerHtml;
          }
        });
      });
    },
    createPaymentMethod() {
      return new Promise(async (resolve) => {
        let userEmail = this.user.email;
        this.showLoading();
        const result = await this.stripe.createPaymentMethod({
          type: "card",
          // card: cardElement,
          card: this.card,
          billing_details: {
            email: userEmail,
          },
        });
        this.hideLoading();
        if (result.error) {
          const errorMessage = result.error.message
            ? result.error.message
            : JSON.stringify(result.error);
          this.showErrorDialog({
            title: "Error when creating Stripe payment method",
            message: errorMessage,
          });
          resolve();
        } else {
          this.paymentMethodId = result.paymentMethod.id;
          resolve(this.paymentMethodId);
        }
      });
    },
    createCustomerAndCharge(user, payment, giftCardCode = null) {
      let userEmail = user.email;
      const userName = `${user.first_name} ${user.last_name}`;
      return new Promise(async (resolve) => {
        const createCustomerRes = await axios.post(
          "/stripe-create-customer-v2/",
          {
            email: userEmail,
            name: userName,
            enginehire_id: user.id,
            payment_method_id: this.paymentMethodId,
            stripe_account: this.$store.getters.agencyPublic.stripe_account_id,
            agency: this.$store.getters.agencyID,
            charge_info: payment,
            charge_description: this.registrationFeeStripeDescription,
            gift_card_code: giftCardCode
          }
        );
        if (payment) {
          if (this.tryGet(() => createCustomerRes.data.charge_success)) {
            // Collect payment successfully
            resolve(true);
            return;
          }
        } else {
          // No payment need
          resolve(true);
          return;
        }
        resolve(false);
      });
    },
    createCustomer(user, payment, jobId, chargeDescription) {
      return new Promise(async (resolve) => {
        let userEmail = this.user.email;
        const userName = `${this.user.first_name} ${this.user.last_name}`;
        const result = await this.stripe.createPaymentMethod({
          type: "card",
          // card: cardElement,
          card: this.card,
          billing_details: {
            email: userEmail,
          },
        });
        if (result.error) {
          const errorMessage = result.error.message
            ? result.error.message
            : JSON.stringify(result.error);
          this.showErrorDialog({
            title: "Error when creating payment method",
            message: errorMessage,
          });
        } else {
          const createCustomerRes = await axios.post(
            "/stripe-create-customer-v2/",
            {
              email: userEmail,
              name: userName,
              enginehire_id: user.id,
              payment_method_id: result.paymentMethod.id,
              stripe_account:
                this.$store.getters.agencyPublic.stripe_account_id,
              agency: this.$store.getters.agencyID,
            }
          );
          if (payment && createCustomerRes && createCustomerRes.data) {
            if (payment.amount) {
              let currency = user.currency || this.agencyCurrency;
              if (!currency) {
                currency = "usd"; // Default currency
              }
              await axios.post(
                `/stripe-collect-payment-from-existing-customer/`,
                {
                  stripe_payer_account:
                    createCustomerRes.data.stripe_customer.id,
                  stripe_payee_account:
                    this.$store.getters.agencyPublic.stripe_account_id,
                  amount: Math.round(payment.amount * 100),
                  receipt_email: userEmail,
                  currency: currency,
                  log: true,
                  agency: this.$store.getters.agencyID,
                  user: user.id,
                  category: "Job",
                  related_id: jobId,
                  description: chargeDescription,
                }
              );
            } else if (payment.subscription) {
              await axios.post("/stripe-create-subscription/", {
                stripe_account:
                  this.$store.getters.agencyPublic.stripe_account_id,
                customer_id: createCustomerRes.data.stripe_customer.id,
                plan_id: payment.subscription.plan_id,
                fee_percentage: payment.subscription.fee_percentage,
                tax_percentage: payment.subscription.tax_percentage,
                coupon: payment.subscription.coupon,
                promotion_code: payment.subscription.promotion_code,
                agency: this.$store.getters.agencyID,
              });
            }
            // Collect payment successfully
            resolve(true);
            return;
          }
        }
        resolve();
      });
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/complex-input-elements/StripePayment.vue